import React from "react";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import dayjs from "dayjs";
//Style
import { Content, Dot, Container, Time } from "./style";
const TimelineComponent = ({ logs }) => {
  const dot = Dot();
  const content = Content();

  return (
    <Container>
      <Timeline>
        {logs.process.map((item, idx) => {
          if (idx === 0) {
            return (
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineDot classes={{ root: dot.root }} />
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent classes={{ root: content.root }}>
                  <Time>{dayjs(item.date).format("DD-MM-YYYY")}</Time> Su caso
                  ha sido registrado en nuestro sistema
                </TimelineContent>
              </TimelineItem>
            );
          }
          if (idx === 1 && !logs.isRejected) {
            return (
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineDot classes={{ root: dot.root }} />
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent classes={{ root: content.root }}>
                  <Time>{dayjs(item.date).format("DD-MM-YYYY")}</Time> El caso
                  esta en tramite por el area de {item.area}
                </TimelineContent>
              </TimelineItem>
            );
          }
          if (idx === 1 && logs.isRejected) {
            return (
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineDot classes={{ root: dot.root }} />
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent classes={{ root: content.root }}>
                  <Time>{dayjs(item.date).format("DD-MM-YYYY")}</Time>
                  {item.payload}
                </TimelineContent>
              </TimelineItem>
            );
          }
          if (idx === 2) {
            return (
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineDot classes={{ root: dot.root }} />
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent classes={{ root: content.root }}>
                  <Time>{dayjs(item.date).format("DD-MM-YYYY")}</Time>
                  {item.payload}
                </TimelineContent>
              </TimelineItem>
            );
          }
        })}
      </Timeline>
    </Container>
  );
};
export default TimelineComponent;
